import { Component } from 'preact'
import WidgetPreview from '../components/widget-preview'
import {
    BackgroundFilter,
    LayoutFilter,
    LinkFilter,
    ItemBackgroundFilter,
    ReviewItemFrameFilter,
    OuterWrapperFrameFilter,
    MinimalRatingFilter
} from '../components/filters'
import { __ } from '../../locales'

class WfDoctifyList extends Component {
    state = {
        selectedLayout: 'WF_LIST_A',
        layoutOptions: [
            { value: 'WF_LIST_A', label: 'List Layout A' },
            { value: 'WF_LIST_B', label: 'List Layout B' }
        ]
    };

    render(props, state) {
        return (
            <WidgetPreview
                {...props}
                name={__('widget.review_list.name')}
                type={'doctify-list-widget'}
                extraParams={[
                    'slugs',
                    'background',
                    'itemBackground',
                    'rating',
                    'outerFrame',
                    'itemFrame',
                    'linkUrl',
                ]}
                description={__('widget.review_list.description')}
                bestFor={[__('global.homepage'), __('global.footer')]}
                layoutType={state.selectedLayout}
                badgeTitle={__('widget.type.carousel')}
                badgeColor={'#2B59E0'}
                badgeFontColor={'#FFFFFF'}
            >
                <div className={'filters-wrapper mt-5 mb-5'}>
                    <BackgroundFilter {...props} />
                    <LayoutFilter
                        selectedLayout={state.selectedLayout}
                        options={state.layoutOptions}
                        onChange={ev => this.setState({ selectedLayout: ev.target.value })}
                    />
                    <LinkFilter
                        {...props}
                        hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
                    />
                    <ItemBackgroundFilter {...props} />
                    <ReviewItemFrameFilter {...props} />
                    <OuterWrapperFrameFilter {...props} />
                    <MinimalRatingFilter {...props} />
                </div>
            </WidgetPreview>
        );
    }
}

export default WfDoctifyList
